import React, { Component } from 'react'
import moment from 'moment';
import config from "../../../config";
import { FORMAT_NUMBER, CURRENCY, SYMBOL, Datos_Empresa } from '../../../libs/utils/Const';
import { development } from "../../../libs/utils/Const";


class Purchasing extends Component {

    render() {
        const { ReportsModel, DocsToPrint } = this.props;
        const today = moment(new Date()).format('MM/DD/YYYY');
        const _user = JSON.parse(localStorage.getItem(config.localStorageNamed + 'currentUser'));
        

        const arraySupplierEntries = (DocsToPrint && DocsToPrint[0]) ? DocsToPrint[0].arraySupplierEntries : [];
        const arraySupplierInvoices = (DocsToPrint && DocsToPrint[0]) ? DocsToPrint[0].arraySupplierInvoices : [];
        const arraySupplierReturns = (DocsToPrint && DocsToPrint[0]) ? DocsToPrint[0].arraySupplierReturns : [];
        const arraySupplierCreditNotes = (DocsToPrint && DocsToPrint[0]) ? DocsToPrint[0].arraySupplierCreditNotes : [];

        return (
            <>
                <table><tr><td>

                    <div style={{ height: "auto", width: "90%", marginLeft: "auto", marginRight: "auto", marginTop: "2.5vw" }}>
                        <div className="row">
                            <div className="col-3">
                                <img src={development? require('../../../images/logo_draft.svg') : require('../../../images/logo_EMPRESA.svg')} alt="Logo" />
                                <p className="text-center">{Datos_Empresa.Nombre} {Datos_Empresa.Sociedad}<br /></p>
                            </div>
                            <div className="col-6 text-center">
                                <h5><strong>INFORME DE COMPRAS</strong></h5>
                            </div>
                            <div className="col-3">
                                <p>FECHA DOC: <strong>{today ?? ''}</strong> <br />Del {moment(ReportsModel.InitialDate).utc().format('MM/DD/YYYY')} al {moment(ReportsModel.FinalDate).utc().format('MM/DD/YYYY')} <br />CÓDIGO SUCURSAL: {_user?.Branch.CodeBranchOffice}</p>
                            </div>
                        </div>

                        <div className='row mt-5' style={{ paddingRight: "15px" }}>
                            <div className='col-12'>
                                {ReportsModel.supplierEntries &&
                                    <>
                                        <h6>Entradas de proveedor</h6>
                                        <table>
                                            <thead style={{ border: "solid 1px" }}>
                                                <tr>
                                                    <th className="text-left pl-3">Fecha</th>
                                                    <th className="text-left">Proveedor</th>
                                                    <th className="text-right">Importe</th>
                                                    <th className="text-right">Impuesto</th>
                                                    <th className="text-right  pr-3">Total</th>
                                                </tr>
                                            </thead>
                                            {arraySupplierEntries.map((suppEntry) => {
                                                return (
                                                    <tbody>
                                                        <tr style={{ fontSize: '12px' }}>
                                                            <td className="text-left pl-3">{moment(suppEntry.DocDate).format('MM/DD/YYYY')}</td>
                                                            <td className="text-left">{suppEntry.CardName ?? ''}</td>
                                                            <td className="text-right">{CURRENCY + ' ' + (FORMAT_NUMBER.new(suppEntry.DocTotal - suppEntry.VatSum) ?? '')}</td>
                                                            <td className="text-right">{CURRENCY + ' ' + (FORMAT_NUMBER.new(suppEntry.VatSum) ?? '')}</td>
                                                            <td className="text-right pr-3">{CURRENCY + ' ' + (FORMAT_NUMBER.new(suppEntry.DocTotal) ?? '')}</td>
                                                        </tr>
                                                    </tbody>
                                                )
                                            })}
                                        </table>
                                    </>
                                }

                                {ReportsModel.supplierInvoices &&
                                    <>
                                        <h6>Facturas de proveedor</h6>
                                        <table>
                                            <thead style={{ border: "solid 1px" }}>
                                                <tr>
                                                    <th className="text-left pl-3">Fecha</th>
                                                    <th className="text-left">Proveedor</th>
                                                    <th className="text-right">Importe</th>
                                                    <th className="text-right">Impuesto</th>
                                                    <th className="text-right  pr-3">Total</th>
                                                </tr>
                                            </thead>
                                            {arraySupplierInvoices.map((suppInvoice) => {
                                                return (
                                                    <tbody>
                                                        <tr style={{ fontSize: '12px' }}>
                                                            <td className="text-left pl-3">{moment(suppInvoice.DocDate).format('MM/DD/YYYY')}</td>
                                                            <td className="text-left">{suppInvoice.CardName ?? ''}</td>
                                                            <td className="text-right">{CURRENCY + ' ' + FORMAT_NUMBER.new(suppInvoice.DocTotal - suppInvoice.VatSum) ?? ''}</td>
                                                            <td className="text-right">{CURRENCY + ' ' + FORMAT_NUMBER.new(suppInvoice.VatSum) ?? ''}</td>
                                                            <td className="text-right pr-3">{CURRENCY + ' ' + FORMAT_NUMBER.new(suppInvoice.DocTotal) ?? ''}</td>
                                                        </tr>
                                                    </tbody>
                                                )
                                            })}
                                        </table>
                                    </>
                                }

                                {ReportsModel.supplierReturns &&
                                    <>
                                        <h6>Devoluciones de proveedor</h6>
                                        <table>
                                            <thead style={{ border: "solid 1px" }}>
                                                <tr>
                                                    <th className="text-left pl-3">Fecha</th>
                                                    <th className="text-left">Proveedor</th>
                                                    <th className="text-right">Importe</th>
                                                    <th className="text-right">Impuesto</th>
                                                    <th className="text-right  pr-3">Total</th>
                                                </tr>
                                            </thead>
                                            {arraySupplierReturns.map((suppReturn) => {
                                                return (
                                                    <tbody>
                                                         <tr style={{ fontSize: '12px' }}>
                                                            <td className="text-left pl-3">{moment(suppReturn.DocDate).format('MM/DD/YYYY')}</td>
                                                            <td className="text-left">{suppReturn.CardName ?? ''}</td>
                                                            <td className="text-right">{CURRENCY + ' ' + FORMAT_NUMBER.new(suppReturn.DocTotal - suppReturn.VatSum) ?? ''}</td>
                                                            <td className="text-right">{CURRENCY + ' ' + FORMAT_NUMBER.new(suppReturn.VatSum) ?? ''}</td>
                                                            <td className="text-right pr-3">{CURRENCY + ' ' + FORMAT_NUMBER.new(suppReturn.DocTotal) ?? ''}</td>
                                                        </tr>
                                                    </tbody>
                                                )
                                            })}
                                        </table>
                                    </>
                                }

                                {ReportsModel.supplierCreditNotes &&
                                    <>
                                        <h6>Notas de crédito de proveedor</h6>
                                        <table>
                                            <thead style={{ border: "solid 1px" }}>
                                                <tr>
                                                    <th className="text-left pl-3">Fecha</th>
                                                    <th className="text-left">Proveedor</th>
                                                    <th className="text-right">Importe</th>
                                                    <th className="text-right">Impuesto</th>
                                                    <th className="text-right  pr-3">Total</th>
                                                </tr>
                                            </thead>
                                            {arraySupplierCreditNotes.map((suppCN) => {
                                                return (
                                                    <tbody>
                                                        <tr style={{ fontSize: '12px' }}>
                                                            <td className="text-left pl-3">{moment(suppCN.DocDate).format('MM/DD/YYYY')}</td>
                                                            <td className="text-left">{suppCN.CardName ?? ''}</td>
                                                            <td className="text-right">{CURRENCY + ' ' + FORMAT_NUMBER.new(suppCN.DocTotal - suppCN.VatSum) ?? ''}</td>
                                                            <td className="text-right">{CURRENCY + ' ' + FORMAT_NUMBER.new(suppCN.VatSum) ?? ''}</td>
                                                            <td className="text-right pr-3">{CURRENCY + ' ' + FORMAT_NUMBER.new(suppCN.DocTotal) ?? ''}</td>
                                                        </tr>
                                                    </tbody>
                                                )
                                            })}
                                        </table>
                                    </>
                                }


                            </div>
                        </div>

                    </div>

                </td></tr></table>
            </>
        )
    }
}

export default Purchasing